import React, { useState } from "react";
import {
  formatDateText,
  initialPaymentInfo,
  paymentMethodsData,
  restrictValue,
  transformPrice,
  usaStates,
} from "./data";
import {
  CheckedBox,
  FipayLogo,
  Footer,
  PageTitle,
  PayBtn,
  PaymentInfoWrapper,
  PaymentMethodWrapper,
  PaymentMethodsWrapper,
  UncheckedCircle,
  AddBankButton,
} from "./PaymentInfo.styled";
import PayWithAccount from "./PayWithAccount";
import { useStore } from "@nanostores/react";
import { paymentInfo as $paymentInfoAtom } from "../../store/nanostore";
import { brandSettings } from "../../store/nanostore";
import { PayWithBank } from "./PayWithBank";
import environment from "../../env";
import { useSearchParams } from "react-router-dom";
import { safeJson } from "../../utils/safeJson";

interface PaymentInfoProps {
  handleNext: (step: number) => void;
  price: number;
}

const PaymentInfo: React.FC<PaymentInfoProps> = () => {
  const [selectedMethod, setSelectedMethod] = useState<string>(
    "visa"
    // paymentMethodsData[0].key
  );
  const [params] = useSearchParams();
  const visaState = safeJson(params.get("state")) || {};
  const $paymentInfo = useStore($paymentInfoAtom);

  const handleSelectPaymentMethod = ({ method }: { method: string }) => {
    setSelectedMethod((prevMethod) => method);
  };

  const handleAddNewBank = () => {
    console.log("Initiating VISA process to add new bank");
  };

  const renderPaymentScreens = (selectedMethod: any) => {
    const type = visaState.simulator ? "simulator" : selectedMethod;

    switch (type) {
      case "visa":
      case "others":
        return <PayWithAccount data={$paymentInfo} />;
      case "pay-with-bank":
      case "pay-with-card":
      default:
        return <PayWithBank />;
      // return <PayWithAccount data={$paymentInfo} />;

      // return (
      //   // <PayWithBank />
      //
      //   <StripeElementApp
      //     clientSecret={$paymentInfo?.paymentIntent?.clientSecret}
      //   >
      //     <></>
      //   </StripeElementApp>
      // );
    }
  };
  return (
    <PaymentInfoWrapper>
      {/*<PageTitle2 $small>Select payment method</PageTitle2>*/}
      {
        <>
          <AddBankButton onClick={handleAddNewBank}>
            + Add a new bank
          </AddBankButton>
          <PaymentMethodsWrapper>
            {paymentMethodsData
              .filter((data) => !data)
              .map((data) => (
                <PaymentMethodWrapper
                  key={data.label}
                  onClick={() =>
                    handleSelectPaymentMethod({ method: data.key })
                  }
                >
                  <i>
                    {selectedMethod === data.key ? (
                      <CheckedBox />
                    ) : (
                      <UncheckedCircle />
                    )}
                  </i>
                  <div className="flex">
                    <i>{data.icon}</i>
                    <span>{data.label}</span>
                  </div>
                </PaymentMethodWrapper>
              ))}
          </PaymentMethodsWrapper>
          {renderPaymentScreens(selectedMethod)}
          {/*<BillingAddressInfo />*/}
        </>
      }
      <Footer>
        Secured by <FipayLogo />
      </Footer>
    </PaymentInfoWrapper>
  );
};

export default PaymentInfo;
